import { render, staticRenderFns } from "./partner-join.vue?vue&type=template&id=ed6acad2&scoped=true&lang=pug"
import script from "./partner-join.vue?vue&type=script&lang=js"
export * from "./partner-join.vue?vue&type=script&lang=js"
import style0 from "./partner-join.vue?vue&type=style&index=0&id=ed6acad2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6acad2",
  null
  
)

export default component.exports